export type TBrand = Array<{
  id: string;
  logo: string;
}>;

interface IBrandSlider {
  brands: TBrand;
  direction?: 'left' | 'right';
}

export const BrandSlider: React.FC<IBrandSlider> = ({
  brands,
  direction = 'right',
}) => {
  return (
    <div className="slider-h my-8 sm:my-4">
      <div className={`slide-track animate-${direction}`}>
        {brands.map((brand) => {
          return (
            <div
              key={brand.id}
              className="slide border border-gray-200 rounded-3xl mx-5 w-1/12 h-20"
            >
              <img
                loading="lazy"
                className="w-8/12 h-auto mx-auto"
                src={brand.logo}
                alt="img"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
